exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-content{display:-webkit-box;display:-ms-flexbox;display:flex}.tab-content .tab-pane{display:block;-webkit-animation:fadeIn .5s;animation:fadeIn .5s;width:100%}.wizard-navigation .nav-link.active,.wizard-navigation .nav-link.checked{cursor:pointer}.disabled-wizard-link{cursor:not-allowed}", ""]);

// exports
